<template>
  <section class="content">
    <row>
      <div class="col-md-12">
        <CustomTab>
          <div slot="content" class="active" id="tabSites" title="Sites">
            <Sites :hideFilter="hideFilter"></Sites>
          </div>
          <div slot="content" id="tabPrinters" title="Printers">
            <Printers hideFilter="true"></Printers>
          </div>
          <div slot="content" id="tabHistory" title="History">
            <PrintHistory></PrintHistory>
          </div>
        </CustomTab>
      </div>
    </row>
  </section>
</template>
<script>
  import CustomTab from '../components/VACustomTab.vue'
  import Dealers from './Dealers'
  import Sites from './Sites'
  import Printers from './Printers'
  import PrintHistory from './PrintHistory'
  import Users from './Users'
  import Reports from './Reports'

  export default {
    name: 'counter',
    components: { CustomTab, Dealers, Sites, Printers, PrintHistory, Users, Reports },
    data () {
      return {
        hideFilter: true,
        msgHello: 'Hello',
        msgBye: 'Bye',
        loading: false
      }
    },
    created () {
      this.$root.title = 'Printer Counter Monitoring'
    },
    methods: {
      clickBtn () {
        console.log('clickBtn ...')
        this.loading = !this.loading
        setTimeout(() => {
          this.loading = !this.loading
        }, 1000)
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// Counter.vue?755c3411